export class Defaults {
  static readonly REQUEST_LIMIT = 50;
  static readonly DEBOUNCE_TIME = 400;
  static readonly MIN_TOKEN_EXPIRATION_THRESHOLD = 5;
  static readonly TABLE_SORT_BY = '-updated_at';
  static readonly RPX_EMAIL = 'rpxsupport@productsup.com';
}
